// calling both current and archived teacher
export const SELECT_MULTIPLE_STUDENT = 'SELECT_MULTIPLE_STUDENT';

export function selectStudent(students) {
  return {
    type: SELECT_MULTIPLE_STUDENT,
    students,
  }
}

const initState = {
  multiSelectedStudents: []
}

export default function(state = initState, action){
  switch(action.type){
    case SELECT_MULTIPLE_STUDENT: {
      return {
        ...state,
        multiSelectedStudents: action.students,
      }
    }
    default: 
      return state;
  }
}

//



// WEBPACK FOOTER //
// ./src/containers/pages/Student/ducks.js